import { styled } from '@mui/material';

export const CaretLoadingIndicator = () => (
  <Container>
    <div className='block firstBlock'></div>
    <div className='block secondBlock'></div>
    <div className='block thirdBlock'></div>
  </Container>
);

const Container = styled('div')`
  height: 54px;
  width: 54px;
  animation: containerAnimation 1.2s linear infinite;

  & .block {
    height: 28px;
    width: 28px;
    background: var(--mui-palette-text-primary);
    position: absolute;
  }

  & .firstBlock {
    animation: firstBlockAnimation 1.2s ease-out infinite;
  }

  & .secondBlock {
    animation: secondBlockAnimation 1.2s ease-out infinite;
  }

  & .thirdBlock {
    animation: thirdBlockAnimation 1.2s ease-out infinite;
  }

  @keyframes containerAnimation {
    0%,
    36% {
      transform: rotate(0deg);
    }
    58%,
    100% {
      transform: rotate(90deg);
    }
  }

  @keyframes firstBlockAnimation {
    0% {
      transform: translate3d(0px, 11px, 0px);
    }

    18%,
    48% {
      transform: translate3d(0px, 27px, 0px);
    }
    62% {
      transform: translate3d(11px, 0px, 0px);
    }

    72% {
      transform: translate3d(38px, 0px, 0px);
    }

    88% {
      transform: translate3d(38px, 27px, 0px);
    }

    100% {
      transform: translate3d(11px, 27px, 0px);
    }
  }

  @keyframes secondBlockAnimation {
    0% {
      transform: translate3d(0px, 11px, 0px);
    }

    18%,
    48% {
      transform: translate3d(0px, 0px, 0px);
    }

    62% {
      transform: translate3d(11px, 0px, 0px);
    }

    72% {
      transform: translate3d(38px, 0px, 0px);
    }

    88% {
      transform: translate3d(38px, 27px, 0px);
    }

    100% {
      transform: translate3d(11px, 27px, 0px);
    }
  }

  @keyframes thirdBlockAnimation {
    0% {
      transform: translate3d(0px, 11px, 0px);
    }

    18%,
    48% {
      transform: translate3d(27px, 0px, 0px);
    }

    62%,
    72% {
      transform: translate3d(38px, 0px, 0px);
    }

    88% {
      transform: translate3d(38px, 27px, 0px);
    }

    100% {
      transform: translate3d(11px, 27px, 0px);
    }
  }
`;
